import { MealSwapFilterOptionWithSubFilters } from "@/clients/models/MealSwapFilterOptionWithSubFilters";

export const DEFAULT_FILTER = "recipes";
export const FILTER_PARAM = "filter";
export const SUB_FILTER_PARAM = "subFilter";

export const getEffectiveFilter = (searchParams: URLSearchParams) => {
  return searchParams.get(FILTER_PARAM) ?? DEFAULT_FILTER;
};

export const getEffectiveSubFilter = (searchParams: URLSearchParams) => {
  return searchParams.get(SUB_FILTER_PARAM) ?? undefined;
};

/**
 * Parses a URL search parameter as a list of values.
 * Supports both multiple parameters with the same key and comma-separated values.
 */
export const parseParamList = (searchParams: URLSearchParams, key: string) => {
  const values = searchParams.getAll(key);
  if (values.length > 0) {
    return values;
  }

  const fallback = searchParams.get(key);
  if (!fallback) {
    return [];
  }

  return fallback
    .split(",")
    .map((value) => value.trim())
    .filter((value) => value.length > 0);
};

export const getDefaultFilterOption = (
  options: MealSwapFilterOptionWithSubFilters[],
): MealSwapFilterOptionWithSubFilters | null => {
  if (options.length === 0) {
    return null;
  }

  return options.find((option) => option.value === DEFAULT_FILTER) ?? options[0];
};
